// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OfflineTrafficState, STATE_NAME } from './offline-traffic.reducer';

export const offlineTrafficState = createFeatureSelector<OfflineTrafficState>(STATE_NAME);

export const selectIsLoading = createSelector(
  offlineTrafficState,
  (state: OfflineTrafficState) => state.isLoading,
);

export const selectOfflineTrafficError = createSelector(
  offlineTrafficState,
  (state: OfflineTrafficState) => state.offlineTrafficError,
);

export const selectOfflineTraffic = createSelector(
  offlineTrafficState,
  (state: OfflineTrafficState) => state.offlineTraffic,
);
